// extracted by mini-css-extract-plugin
export default {"cabecera":"CabeceraTorneosInt_cabecera__qB2WM","volver":"CabeceraTorneosInt_volver__jxGjx"};